"use client";
import type { Tour } from "@/types/tour";
import Image from "next/image";

import Link from "next/link";
import { memo } from "react";

function extractDescription(longTitle: string | undefined) {
  if (!longTitle) return "";
  const maxLength = 100;
  if (longTitle.length <= maxLength) return longTitle;
  return longTitle.substring(0, maxLength) + "...";
}

function TourGridCard({ tour }: { tour: Tour }) {
  const slug = tour.url.split("/").pop() ?? "";
  const price =
    tour.promo_price && tour.promo_price !== "" ? tour.promo_price : "0";

  const discountedPrice =
    tour.promo_price_discounted && tour.promo_price_discounted !== ""
      ? tour.promo_price_discounted
      : null;
  const date =
    typeof tour.promo_date === "string" ? tour.promo_date : undefined;
  const available =
    tour.dates_toggle === "true" ||
    tour.dates_toggle === true ||
    tour.dates_toggle === "";

  const overlayImage = "/assets/vylet2.svg";
  return (
    <Link href={`/vylety/${slug}`} passHref>
      <div className='relative max-w-sm p-4 cursor-pointer group rounded-lg flex flex-col'>
        <div
          className={`absolute top-4 left-4 z-10 ${
            discountedPrice ? "bg-[#DF0024]" : "bg-[#DF0024]"
          } text-white font-bold text-sm rounded-full w-16 h-16 flex flex-col items-center justify-center`}
        >
          {discountedPrice ? (
            <>
              {/* <span className='line-through text-[#822424] text-xs'>
                {price} €
              </span> */}
              <span className='text-base'>{discountedPrice} €</span>
            </>
          ) : (
            <span className='text-base'>{price} €</span>
          )}
        </div>

        <div className='w-auto absolute right-0 top-[38%]'>
          <div className='absolute top-4 px-4 z-20 right-4 bg-[#007AAB] text-white text-sm font-medium py-1 rounded-full'>
            <span className='whitespace-nowrap'>{tour.tag}</span>
          </div>
          {date && (
            <div className='absolute top-13 z-20 px-4 right-4 bg-[#AE27D7] text-white text-sm font-medium py-1 rounded-full'>
              {available ? (
                <span className='text-white whitespace-nowrap'>{date}</span>
              ) : (
                <span className='text-white whitespace-nowrap'>Obsadené</span>
              )}
            </div>
          )}
        </div>

        <div
          className='relative w-75 h-50 bg-white overflow-hidden'
          style={{
            WebkitMaskImage: `url(${overlayImage})`,
            WebkitMaskSize: "contain",
            WebkitMaskRepeat: "no-repeat",
            maskImage: `url(${overlayImage})`,
            maskSize: "contain",
            maskRepeat: "no-repeat",
          }}
        >
          {(tour.header_image?.thumbs?.sm || tour.header_image?.url) && (
            <Image
              src={tour.header_image?.thumbs?.sm ?? tour.header_image!.url}
              alt={tour.title}
              fill
              className='object-cover transition-transform duration-500 ease-out group-hover:scale-110'
              sizes='(max-width: 768px) 100vw, 300px'
              unoptimized
            />
          )}
        </div>

        <div className='flex flex-col items-center justify-center h-20'>
          <h2 className='text-xl font-semibold text-center'>{tour.title}</h2>
          <p className='text-gray-600 text-center text-sm max-w-62.5 line-clamp-2'>
            {extractDescription(tour.long_title)}
          </p>
        </div>

        <div className='flex justify-center mt-auto'>
          <button className='bg-[#00638A] text-white px-10 py-1 rounded-full'>
            {tour.duration}
          </button>
        </div>
      </div>
    </Link>
  );
}

export default memo(TourGridCard);
